import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import StyleVariables from "../../../assets/styles/Variable.module.scss";
import {
  DateBuddhistEra as DateBuddhistEraUtil,
  DateTimeBuddhistEra as DateTimeBuddhistEraUtil,
} from "../../../utils/DateFormat";
import dayjs from "dayjs";
import { NumericFormat } from "react-number-format";
import { ProductWeightType as ProductWeightTypeConstant } from "../../../constants/Gold";
import { Trade as TradeModel } from "../../../models/Trade";
import SouvenirsBill from "../Souvenirs";

type Props = {
  trade: TradeModel | null;
};

const SellCancel = observer((props: Props) => {
  return (
    <Box color={StyleVariables["color-text"]}>
      {/* Heading */}
      <Box borderBottom={`1px dashed ${StyleVariables["color-border"]}`}>
        {/* Branch Name && Ref Invoice Number */}
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          gap={1}
          marginBottom={1}
        >
          <Typography variant="subtitle2" fontWeight={"regular"}>
            {props.trade?.branchName}
          </Typography>
          <Typography variant="subtitle2" fontWeight={"regular"}>
            {props.trade?.refInvoiceNo}
          </Typography>
        </Box>
        {/* /.Branch Name && Ref Invoice Number */}

        {/* Employee Name && Cancel Date */}
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          gap={1}
          marginBottom={2}
        >
          <Typography variant="subtitle2" fontWeight={"regular"}>
            {props.trade?.cancelByUserFirstName}{" "}
            {props.trade?.cancelByUserLastName &&
              props.trade?.cancelByUserLastName[0]}
            .
          </Typography>
          <Typography variant="subtitle2" fontWeight={"regular"}>
            {props.trade?.cancelAt
              ? DateTimeBuddhistEraUtil(props.trade?.cancelAt)
              : `${DateBuddhistEraUtil(dayjs())} --:--`}
          </Typography>
        </Box>
        {/* /.Employee Name && Cancel Date */}
      </Box>
      {/* /.Heading */}

      {/* Product List && Reason */}
      <Box marginY={2}>
        <Grid container spacing={0.5} alignItems={"center"}>
          <Grid item xs={7}>
            <Typography variant="subtitle2" fontWeight={"regular"}>
              {props.trade?.productName} จำนวน {props.trade?.totalQuantity} ชิ้น
            </Typography>
            <Typography
              variant="subtitle2"
              fontWeight={"regular"}
              marginTop={1}
            >
              {props.trade?.productType ===
              ProductWeightTypeConstant.equalWeight
                ? `(นน.${parseFloat(
                    props.trade?.tradeHasItems[0]?.weight.toFixed(3)
                  )} กรัม/ชิ้น)`
                : `(นน.รวม${parseFloat(
                    props.trade?.totalWeight.toFixed(3) || "0"
                  )} กรัม)`}
            </Typography>
          </Grid>
          <Grid
            item
            xs={5}
            textAlign={"right"}
            sx={{ wordBreak: "break-word" }}
          >
            <Typography variant="subtitle2" fontWeight={"regular"}>
              <NumericFormat
                value={props.trade?.netPay}
                displayType="text"
                thousandSeparator
              />
            </Typography>
          </Grid>
        </Grid>

        <SouvenirsBill
          souvenirs={props.trade?.souvenirs}
          showBorderTop={true}
          showBorderBottom={false}
        />

        <Typography
          variant="subtitle2"
          fontWeight={"regular"}
          marginTop={2}
          paddingBottom={2}
          textAlign={"center"}
          whiteSpace={"break-spaces"}
          borderBottom={`1px dashed ${StyleVariables["color-border"]}`}
        >
          {"ยกเลิก  ยกเลิก  ยกเลิก  ยกเลิก  ยกเลิก"}
        </Typography>
        <Typography variant="subtitle2" fontWeight={"regular"} marginTop={2}>
          เหตุผล:{" "}
          {`${props.trade?.cancelReason?.reason} ${
            props.trade?.cancelMisc || ""
          }`}
        </Typography>
      </Box>
      {/* /.Product List && Reason */}
    </Box>
  );
});

export default SellCancel;
